// extracted by extract-css-chunks-webpack-plugin
module.exports = {"display-none":"display-none_Txtg5","shortDesc":"shortDesc_sUL8P","shortDescExpanded":"shortDescExpanded_nerhA"};